var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.664,
    viewBox: "0 0 19.5 19.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Users_default_16px",
    transform: "translate(-368.728 -193.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160588",
    "data-name": "Group 160588",
    transform: "translate(369.478 193.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3228",
    "data-name": "Group 3228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M14.931,19.64A7.251,7.251,0,0,0,21.085,19v-.188c0-2.518-1.687-4.562-3.756-4.562a3.631,3.631,0,0,0-3.109,2",
    transform: "translate(-3.085 -3.419)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 3.072,
    cy: 3.072,
    r: 3.072,
    transform: "translate(2.797)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3227",
    "data-name": "Group 3227",
    transform: "translate(0 9.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M13.873,19.349v.114a10.175,10.175,0,0,1-11.623,0v-.114c0-3.641,2.607-6.6,5.816-6.6a5.748,5.748,0,0,1,5.1,3.424",
    transform: "translate(-2.25 -12.75)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M14.93,18.859h0a5.789,5.789,0,0,0-.72-2.8",
    transform: "translate(-3.307 -12.396)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M16.951,10.74A2.391,2.391,0,0,1,17.388,6h0a2.4,2.4,0,0,1,2.343,1.9",
    transform: "translate(-3.153 -2.893)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 0.52,
    cy: 0.52,
    r: 0.52,
    transform: "translate(15.548 6.91)",
    fill: "#165cf3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersDarkIcon);
export default __webpack_public_path__ + "static/media/users-dark-icon.87e6dd234d034884410fe74713b2afee.svg";
export { ForwardRef as ReactComponent };